import { DefinitionDto } from "app/modules/shared/model/definition.dto";

export class LemDto extends DefinitionDto {
    active: string;
    address: string;
    city: string;
    company_title: string;
    country: string;
    district: string;
    file_version: string;
    filo: string;
    ids: string;
    lem_end_date: number;
    license_flags: string[];
    logo_license_flags: string;
    logo_product_key: string;
    master_db_create_date: number;
    master_db_id: string;
    master_db_name: string;
    product_id: string;
    product_version: string;
    sql_server_name: string;
    sql_server_thumbprint: string;
    tax_nr: string;
    tax_office: string;
    branch_count:number;
    customer:any;
}